export const GET_POD_TEMPLATE_DATA = `app/NodeViewLayouts/K8sWorkload/GET_POD_TEMPLATE_DATA`
export const GET_POD_TEMPLATE_DATA_SUCCESS = `app/NodeViewLayouts/K8sWorkload/GET_POD_TEMPLATE_DATA_SUCCESS`
export const GET_POD_TEMPLATE_DATA_ERROR = `app/NodeViewLayouts/K8sWorkload/GET_POD_TEMPLATE_DATA_ERROR`

export const GET_CLUSTER_INFRASTRUCTURE = `app/NodeViewLayouts/K8sWorkload/GET_CLUSTER_INFRASTRUCTURE`
export const GET_CLUSTER_INFRASTRUCTURE_SUCCESS = `app/NodeViewLayouts/K8sWorkload/GET_CLUSTER_INFRASTRUCTURE_SUCCESS`
export const GET_CLUSTER_INFRASTRUCTURE_ERROR = `app/NodeViewLayouts/K8sWorkload/GET_CLUSTER_INFRASTRUCTURE_ERROR`
